import { forwardRef, useRef, useState } from 'react';

export const Input = forwardRef(({ isInvalid, setIsInvalid }, ref) => {
  const [showClearIcon, setShowClearIcon] = useState(false);
  const clearRef = useRef(null);

  const handleChange = (e) => {
    if (isInvalid) setIsInvalid(false);
  };

  return (
    <div className='content'>
      <div className='inp-item-wrap'>
        <input
          ref={ref}
          type='number'
          placeholder='입력해 주세요 (예: 19970508)'
          name=''
          className={`inp-text-01${isInvalid ? ' inp-required' : ''}`}
          maxLength='8'
          onChange={handleChange}
          onFocus={() => {
            setShowClearIcon(true);
          }}
          onBlurCapture={(e) => {
            setShowClearIcon(false);
          }}
        />
        {showClearIcon && (
          <button
            type='button'
            className='btn-clear'
            ref={clearRef}
            onMouseDown={() => {
              ref.current.value = '';
              handleChange();
            }}
          >
            <span className='icon icon_clear2'>입력된 내용 지우기</span>
          </button>
        )}
      </div>
      {isInvalid && <span className='inp-required-text'>8자리 전체 생년월일을 입력해 주세요.</span>}
    </div>
  );
});
